/*
 * @Desc: 权限控制
 * @Author: zcc
 * @Date: 2021-02-01 15:11:07
 * @LastEditors: zhangyi zhangy.cosmo@haier.com
 * @LastEditTime: 2024-01-31 09:40:48
 */
import router from './router'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import store from '@/store'
import Cookies from 'js-cookie'
NProgress.configure({ showSpinner: false }) // NProgress Configuration

// let token =sessionStorage.getItem('token')
let token =window.location.hostname === 'baas.cosmoplat.com'?Cookies.get('cosmoplat-cosmoplatuuctoken'):Cookies.get('test-cosmoplat-cosmoplatuuctoken')
router.beforeEach(async(to, from, next) => {
  NProgress.start()
  document.title = getPageTitle(to.meta.title)
  const { code } = to.query
  debugger 
  if (!token){
    console.log('notoken,interfacegGetUserInfo')
    await store.dispatch('interfacegGetUserInfo')
    
  }else{
   
      console.log('hastoken,interfacegGetUserInfo')
      await store.dispatch('interfacegGetCodeToken', { uucToken:token })
      await store.dispatch('interfacegGetUserInfo')
       next()
   
  }
  
  next()
  NProgress.done()
})

router.afterEach(() => {
  NProgress.done()
})

const getPageTitle = (pageTitle) => {
  if (pageTitle) {
    return `${pageTitle} - ${process.env.VUE_APP_BASE_NAME}`
  }
  return `${process.env.VUE_APP_BASE_NAME}`
}
